import React from 'react';
import { Query } from 'react-apollo';
import currentUserQuery from './graphql/query/currentUser';
import { defaults } from '../../config/client';

class CurrentUserNotRedirect extends React.Component {
	render() {
		return (
			<Query query={currentUserQuery} fetchPolicy="network-only">
				{({ loading, error, data, client }) => {
					if (loading || error) return null;

					if (!loading && !error) {
						if (!data.currentUser.result) {
							client.cache.writeData({
								data: defaults,
							});

							localStorage.removeItem('token');
						}

						return this.props.children;
					}
				}}
			</Query>
		);
	}
}

export default CurrentUserNotRedirect;
